import React from 'react';

export default function DaymetCitation() {
  return (
    <div>
      Data source: Thornton; P.E.; M.M. Thornton; B.W. Mayer; Y. Wei; R.
      Devarakonda; R.S. Vose; and R.B. Cook. 2016. Daymet: Daily Surface Weather
      Data on a 1-km Grid for North America; Version 3. ORNL DAAC; Oak Ridge;
      Tennessee; USA.{' '}
      <a href="http://dx.doi.org/10.3334/ORNLDAAC/1328">
        http://dx.doi.org/10.3334/ORNLDAAC/1328
      </a>
    </div>
  );
}
